import React, { useState } from "react";
import { toast } from "react-toastify";
import { getUserInfo } from "../../../../api/ProductAssignment/productAssignment";
import ResponseStatus from "../../../../util/enums";
import "./style.css";

const UserSearch = ({
  value,
  onChange,
  loginType,
  setLoginType,
  onSearch,
  loader,
  user,
}) => {
  return (
    <div className="user-search-box">
      <div className="input-group">
        <select
          value={loginType}
          onChange={(e) => {
            setLoginType(Number(e.target.value));
            onChange("");
          }}
          className="login-type-select"
        >
          <option value={2}>E-posta</option>
          <option value={1}>Telefon</option>
        </select>

        <input
          maxLength={loginType == 1 ? 11 : undefined}
          type={loginType == 1 ? "tel" : "email"}
          inputMode={loginType == 1 ? "numeric" : "email"}
          pattern={loginType == 1 ? "[0-9]*" : undefined}
          className="user-search-input"
          placeholder={
            loginType == 1
              ? "Telefon numarası giriniz..."
              : "E-posta adresi giriniz..."
          }
          value={value}
          onChange={(e) => {
            const input = e.target.value;
            if (loginType == 1) {
              // Only allow digits for phone input
              const onlyNums = input.replace(/[^0-9]/g, "");
              onChange(onlyNums);
            } else {
              // Allow normal characters for email
              onChange(input);
            }
          }}
        />

        <button
          className="primary-btn-UserInfo"
          onClick={onSearch}
          disabled={loader}
        >
          {loader ? "Aranıyor..." : "Ara"}
        </button>
      </div>
      {user && (
        <div>
          <hr className="user-info-divider" />
          <div className="user-info-grid">
            <div className="user-info-item">
              <span className="label">Name-Surname</span>
              <span className="value">{user.NameAndSurname || "-"}</span>
            </div>
            <div className="user-info-item">
              <span className="label">Email</span>
              <span className="value">{user.Email || "-"}</span>
            </div>
            <div className="user-info-item">
              <span className="label">Phone Number</span>
              <span className="value">{user.PhoneNumber || "-"}</span>
            </div>
            <div className="user-info-item">
              <span className="label">User ID</span>
              <span className="value">{user.UserId || "-"}</span>
            </div>
            <div className="user-info-item">
              <span className="label">Nickname</span>
              <span className="value">{user.Nickname || "-"}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserSearch;
